/* NgRx */
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {NotificationsState} from './notifications.reducer';

// Selector functions
const notificationsData =
  createFeatureSelector<NotificationsState>('ss-cord.notifications');

export const fetchNotificationList = createSelector(notificationsData, (state) => state)
 
